import { IElementType } from "../definitions/element";
import { ISpoolElement, ISpoolDetailForPanel } from "../definitions/spools";

export const getSpoolDetails = (
  spoolID: string,
  spools: ISpoolElement[],
  elements: IElementType[],
  sectionID: string,
  page: number
): ISpoolDetailForPanel => {
  const selectedID = spools.find(_spool => _spool.instances.map(_instance => _instance.instanceID).includes(spoolID))?.spoolID;
  const points = elements.filter(
    (_point) =>
      _point.sectionID === sectionID &&
      _point.spoolID === selectedID &&
      _point.page === page
  );
  const spoolDetails: ISpoolDetailForPanel = {
    spoolID: selectedID || "",
    instanceID: spoolID,  
    spoolName:
      spools.find((_spool) => _spool.spoolID === selectedID)?.spoolName || "",
    points: points,
  };
  return spoolDetails;
};

export const getSpoolName = (spoolID: string, spools: ISpoolElement[]) => {
  console.log('spoolID', spoolID, spools);
    return spools.find((_spool) => _spool.spoolID === spoolID)?.spoolName || ""
};
